import { Auth } from 'aws-amplify'

export const namespaced = true

export const state = {
  user: null,
}

export const getters = {
  authenticated: state => !!state.user,
  signedIn: state => !!state.user,
  loggedIn: state => !!state.user,
}

export const mutations = {
  SET_USER: (state, user) => {
    state.user = user
    // localStorage.setItem('user', JSON.stringify(user))
  },
}

export const actions = {
  signOut: async ({ commit }) => {
    await Auth.signOut()
    commit('SET_USER', null)
  },
}
